import { Link } from "@/components/common/Link";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
export default function Footer() {
  return <footer className="w-full bg-dark-background border-t border-border-strong">
      <div className="max-w-7xl mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {}
          <div className="flex flex-col gap-4">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524028/img/bb_veterans_logo.png" alt="B&B VETERANS LLC" className="h-7" />
            <address className="not-italic text-muted-foreground text-sm">
              123 Main St<br />
              Springfield
            </address>
          </div>

          {}
          <div className="flex flex-col gap-3">
            <h3 className="text-light-background font-semibold text-sm mb-2">Quick Links</h3>
            <nav className="flex flex-col gap-2">
              <Link to="/HomePage" className="text-muted-foreground text-sm hover:text-light-background hover:underline transition-colors duration-[var(--duration-fast)]">
                Home
              </Link>
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-3">
            <h3 className="text-light-background font-semibold text-sm mb-2">Follow Us</h3>
            <div className="flex gap-4">
              <Link to="https://facebook.com" newTab className="text-muted-foreground hover:text-secondary transition-colors duration-[var(--duration-fast)]" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
              <Link to="https://twitter.com" newTab className="text-muted-foreground hover:text-secondary transition-colors duration-[var(--duration-fast)]" aria-label="Twitter">
                <Twitter className="size-5" />
              </Link>
              <Link to="https://instagram.com" newTab className="text-muted-foreground hover:text-secondary transition-colors duration-[var(--duration-fast)]" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
              <Link to="https://linkedin.com" newTab className="text-muted-foreground hover:text-secondary transition-colors duration-[var(--duration-fast)]" aria-label="LinkedIn">
                <Linkedin className="size-5" />
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="mt-12 pt-8 border-t border-border">
          <p className="text-muted-foreground text-sm text-center">
            &copy; {new Date().getFullYear()} B&B VETERANS LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}